import "./App.css";
import React, { useEffect } from "react";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import Dashboard from "./components/dashboard/Dashboard";
import Login from "./components/Login/Login";
import Library from "./components/Library/Library";
import ChartMain from "./components/ChartWindow/ChartMain";
import History from "./components/History/History";
import OnboardAvatar from "./components/Avatar/OnboardAvatar";
import Favorites from "./components/Favorites/Favorites";
import RecentPrompts from "./components/Recent-Prompts/RecentPrompts";
import AzureAuth from "./components/Azure_auth/AzureAuth";
import Launch from "./components/Launch/Launch";
import TagHome from "./components/Role/TagHome";
import GPT from "./components/gpt/GPT";
import SourcePDFView from "./components/ChartWindow/SourcePDFView";
import MobileSignin from "./components/Mobile/MobileSignin";

//

import { Amplify } from "aws-amplify";

import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import awsExports from "./aws-exports";
import Register from "./components/Login/Register";
Amplify.configure(awsExports);

//components path
// const Login = React.lazy(() => import("./components/Login/Login"));
// const Library = React.lazy(() => import("./components/Library/Library"));
// const ChartMain = React.lazy(() =>
//   import("./components/ChartWindow/ChartMain")
// );

const router = [
  // {
  //   path: "/",
  //   element: <Login />,
  // },
  // {
  //   path: "/signin",
  //   element: <Login />,
  // },
  // {
  //   path: "/launch",
  //   element: <Launch />,
  // },
  {
    path: "/avatarhub/enterprise",
    element: <Library pagetype="enterprice" />,
  },
  {
    path: "/avatarhub/general",
    element: <Library pagetype="general" />,
  },
  {
    path: "/chat/:id",
    element: <ChartMain />,
  },
  // {
  //   path: "/chat/:id/vertexai",
  //   element: <ChartMain />,
  // },
  {
    path: "/chat/:id/:conversationId",
    element: <ChartMain />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/history",
    element: <History />,
  },
  {
    path: "/onboard_avatar",
    element: <OnboardAvatar />,
  },
  {
    path: "/favorites",
    element: <Favorites />,
  },
  {
    path: "/recent_prompts",
    element: <RecentPrompts />,
  },
  {
    path: "/azure-auth",
    element: <AzureAuth />,
  },
  {
    path: "/tag",
    element: <TagHome />,
  },
  {
    path: "/gpt",
    element: <GPT />,
  },
  {
    path: "/pdf/:url",
    element: <SourcePDFView />,
  },
  {
    path: "/mobilesignin",
    element: <MobileSignin />,
  },
];

function App() {
  const userName = localStorage.getItem("AIVolveXIdentityServiceProvider.auth")
    ? atob(localStorage.getItem("AIVolveXIdentityServiceProvider.auth"))
    : "";

  // useEffect(() => {
  //   console.log("username");
  //   console.log(userName);
  //   console.log(window.location.pathname);
  // }, [window.location.pathname]);

  return (
    <div className="App">
      {/* <Authenticator>
        {({ signOut, user }) => (
          <main>
            <h1>Hello {user.username}</h1>
            <button onClick={signOut}>Sign out</button>
          </main>
        )}
      </Authenticator> */}

      <BrowserRouter>
        {userName ? (
          <>
            <Routes>
              {router.map((val) => (
                <Route path={val.path} key={val.path} element={val.element} />
              ))}
              <Route
                path="*"
                element={<Navigate replace to="/avatarhub/enterprise" />}
              />
            </Routes>
          </>
        ) : (
          <>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<Register />} />
              <Route path="/azure-auth" element={<AzureAuth />} />
              <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
          </>
        )}
        {/* <Routes>
          {router.map((val) => (
            <Route path={val.path} key={val.path} element={val.element} />
          ))}
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
